import React from "react";
import PageBanner from "../components/PageBanner";
import Sidebar from "../components/Sidebar";
import { DR_SHANNON, PAGE_BANNERS } from "../data/content";

export default function DrShannon() {
  return (
    <div>
      <PageBanner src={PAGE_BANNERS.drShannon} alt="Dr. Shannon May" fallbackKey="drShannon" />
      <div className="flex flex-col lg:flex-row gap-8">
        <Sidebar />
        <article className="flex-1 nn-content">
          <h1>{DR_SHANNON.title}</h1>
          {DR_SHANNON.paragraphs.map((p) => (
            <p key={p.slice(0, 32)}>{p}</p>
          ))}
        </article>
      </div>
    </div>
  );
}
